import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInpItImbottigliamento from '../../../component/Produzioni/TableInpItImbottigliamento';
import Model from '../../../component/Produzioni/Model';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { useDispatch, useSelector } from 'react-redux';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';

const ImbottigliamentoeStoccaggio = ({ option, activeStep, setActiveStep }) => {
  const dispatch = useDispatch();
  const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
  const submitForm = useSelector((state) => state.produzioniForm.submitForm);

  const [tableData, setTableData] = useState([
    { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_imottigliamento: null, lotto_di_produzione: "", stabili_id: "", temp_stoccaggio: "" },
  ]);

  const [treatment, setTreatment] = useState([
    { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
  ]);

  const [open, setOpen] = useState(false)
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [imageFile, setImageFile] = useState(null)

  const handleImageUpload = (event, setImage) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImage(reader.result);
      reader.readAsDataURL(file);
    }
  };
  const handleShow = () => {
    setImageFile(frontImage)
    setOpen(false)
  }

  console.log(imageFile, "imagefile")


  const data = {
    id: 1,
    title: "Imbottigliamento e stoccaggio ",
    description:
      "Verifica la corretta sanificazione delle bottiglie e monitora la temperatura di stoccaggio per conservare il vino al meglio.",
    buttonText: "Completa fase",
  };
  const dummyData = {

    temperatureCompliance: tableData.reduce((acc, item) => acc + Number(item.lotto_di_produzione), 0),
    totalCollected: tableData.length,
    discardedGrapes: (tableData.reduce((acc, item) => acc + Number(item.temp_stoccaggio), 0)/tableData.length).toFixed(2),
    tasks: [
      "Imbottigliamento del vino",
      "Etichettatura e identificazione lotto",
      "Stoccaggio nelle condizioni ottimali",
    ],
  };

  const infoFields = [
    { label: "Numero lotti", key: dummyData.temperatureCompliance },
    { label: "Numero Stabilimenti", key: dummyData.totalCollected },
    { label: "Temperatura Stoccaggio", key: dummyData.discardedGrapes },
    { label: "Etichetta", showIcon: true },
  ];

  const fetchDataForUpdate = async () => {
    try {
      const payload = {
        company_id: localStorage.getItem('company_id'),
        step: activeStep,
        prod_id: singleProduzioneID,
      };

      const response = await produzioniFormAPI.getSingleStepFormData(payload);
      console.log(response, "response racolta")
      if (response?.data.data.stoccaggio?.length) {
        const existingTable = response.data.data.stoccaggio;
        setTableData(existingTable);
      }
      if (response?.data.data.production_step_treatment?.length) {
        const existingTreatment = response.data.data.production_step_treatment;
        setTreatment(existingTreatment);
      }
    } catch (error) {
      console.error("Error fetching single step form data:", error);
    }
  };

  useEffect(() => {
      fetchDataForUpdate();
  }, []);

  const onSubmit = async (tableData, treatment) => {
    const data = {
      step: activeStep,
      forms: {
        stoccaggio: tableData,
        production_step_treatment: treatment
      }
    }
    console.log("Submitted data:", data);
    try {
        await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
      
      setActiveStep((prev) => prev + 1);
    } catch (error) {
      fetchDataForUpdate();
      console.error('Error submitting form data:', error);
    }
  };

  useEffect(() => {
    if (submitForm) {
      onSubmit(tableData, treatment);
      dispatch(resetFormSubmit());
    }
  }, [submitForm, dispatch]);

  return (
    <>
      {open && <Model open={open} setOpen={setOpen} frontImage={frontImage} setFrontImage={setFrontImage}
        backImage={backImage} setBackImage={setBackImage} handleImageUpload={handleImageUpload} handleShow={handleShow} />}
      <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
      <DashboardCard dummyData={dummyData} infoFields={infoFields} file={true} open={open} setOpen={setOpen} imageFile={imageFile} />
      <TableInpItImbottigliamento
        option={option}
        rows={tableData}
        setRows={setTableData}
        activeStep={activeStep}
      />
      <TrattamentiFrom
        option={option}
        rows={treatment}
        setRows={setTreatment}
        activeStep={activeStep}
      />

    </>
  )
}

export default ImbottigliamentoeStoccaggio